export const API_CONFIG = {

  // BASE_URL: process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000',
  BASE_URL: process.env.REACT_APP_API_URL || 'https://app.harusi.online',
  TIMEOUT: 30000,
  USE_MOCK: process.env.REACT_APP_USE_MOCK === 'true',
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'X-Platform': 'web',
  }
};

export const STORAGE_KEYS = {
  TOKEN: 'harus_auth_token',
  USER: 'harus_user_data',
  UID: 'harus_event_uid',
  REFRESH_TOKEN: 'harus_refresh_token',
  USER_ID: 'harus_user_id',
  EVENT_ID: 'harus_event_id'
};

export const API_VERSION = '/api';